export default __webpack_public_path__ + "static/media/store.33e1363f.svg";